module.exports = __webpack_public_path__ + "05_glasses_red.d6389bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/05_glasses_red.png
// module id = YyJA
// module chunks = 0